export { default as getScript } from './utils/get-script';

export const i18n = (...args) =>
  typeof window !== 'undefined'
    ? window.Messages(...args) // Used in BROWSER : default i18n function
    : `@messages.at("${args}")`; // Used in SVELTE SSR : output a scala translatation method

export const isProd =
  typeof window !== 'undefined' ? window.tc_vars.env_work === 'prod' : 'prod';

export const getBoolean = val => {
  // Should behave as Java `public boolean asBoolean()`
  //    Method that will try to convert value of this node to a Java boolean.
  //    JSON booleans map naturally; integer numbers other than 0 map to true,
  //    and 0 maps to false and Strings 'true' and 'false' map to corresponding values.
  //    If representation can not be converted to a boolean value (including structured types like Objects and Arrays), default value of false will be returned; no exceptions are thrown.
  if (val === 'false') return false;
  else if (val === 'true') return true;
  return val;
};

export const countryLangs = () => {
  const langs = cube.config.play_i18n_langs;
  return langs
    .replace('[', '')
    .replace(']', '')
    .replace(' ', '')
    .split(',');
};

export const isMonoLanguage = () => {
  const langs = countryLangs();
  if (langs.length > 1) return false;
  return true;
};

export const isAbsoluteLink = url => /^(?:[a-z]+:)?\/\//i.test(url);

export const getCurrentLocale = () =>
  document.querySelector('html').dataset.lang;

export const localizeUri = targetPath => {
  let path = targetPath;
  if (!isMonoLanguage() && !isAbsoluteLink(path)) {
    if (targetPath.charAt(0) !== '/') path = `/${path}`;
    path = `/${getCurrentLocale() + path}`;
  }
  return path;
};

export const switchLocaleUrl = lang => {
  let url = window.location.href;
  if (!lang || !url.indexOf(window.tc_vars.env_language)) return url;

  if (
    url.lastIndexOf(window.tc_vars.env_language) ===
    url.length - window.tc_vars.env_language.length
  )
    url = url.replace(`/${window.tc_vars.env_language}`, `/${lang}`);
  else url = url.replace(`/${window.tc_vars.env_language}/`, `/${lang}/`);

  return url;
};

export const imageResolver = (url, params) => {
  if (!url) return '';
  if (!params) return url;
  let finalUrl = url;

  const { extension, size } = params;

  if (extension && url.includes('.'))
    finalUrl = finalUrl.substring(0, finalUrl.lastIndexOf('.') + 1) + extension;

  if (size) finalUrl = `${finalUrl}?f=${size}`;

  return finalUrl;
};

export const tnrKey = (node, string) => {
  node.setAttribute(string, '');
};




/* eslint-disable prefer-promise-reject-errors */
/*
 * This function allows to execute an array of promises one after the other.
 * If the promise list contains an array of promises, they will be processed in parallel (via Promise.all)
 * See https://jsfiddle.net/3q0knytv/1/
*/
export const waterfall = requestsArray => new Promise((resolve, reject) => {
  const globalResponse = [];

  const sendRequest = index => {
    if (index === requestsArray.length) resolve(globalResponse);

    else {
      const request = requestsArray[index];

      // Request is a Promise
      if (!request.length) request()
        .then(response => { globalResponse[index] = response; })
        .then(() => sendRequest(index + 1))
        .catch(error => reject({ error, reponse: globalResponse }))
      ;


      // request is a group of Promises
      else Promise.all(request.map( req => req() ))
        .then(response => { globalResponse[index] = response; })
        .then(() => sendRequest(index + 1))
        .catch(error => reject({ error, reponse: globalResponse }))
      ;
    }
  };

  sendRequest(0);
});


const regionalLetters = {
  a: '🇦',
  b: '🇧',
  c: '🇨',
  d: '🇩',
  e: '🇪',
  f: '🇫',
  g: '🇬',
  h: '🇭',
  i: '🇮',
  j: '🇯',
  k: '🇰',
  l: '🇱',
  m: '🇲',
  n: '🇳',
  o: '🇴',
  p: '🇵',
  q: '🇶',
  r: '🇷',
  s: '🇸',
  t: '🇹',
  u: '🇺',
  v: '🇻',
  w: '🇼',
  x: '🇽',
  y: '🇾',
  z: '🇿'
};

export const getFlag = (countryCode = '') =>
  countryCode.split('').reduce((flag, letter) => flag + regionalLetters[letter.toLowerCase()], '');



// WEBPACK FOOTER //
// ./src/commons/utils.js